import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Table from "material-ui/Table";
import TBody from "material-ui/Table/TableBody";
import Thead from "material-ui/Table/TableHead";
import Tc from "material-ui/Table/TableCell";
import Tr from "material-ui/Table/TableRow";
import Paper from "material-ui/Paper";
import toFixed from "utils/toFixed";

const styleTable = {
  head: {
    backgroundColor: "#3F51B5",
    opacity: 1.79,
    color: "#E8EAF6",
    fontWeight: "bold",
    paddingLeft: 10,
    paddingRight: 10,
    textAlign: "center"
  },
  odd: {
    backgroundColor: "#C5CAE9",
    opacity: 1.79,
    height: 80
  },
  even: {
    backgroundColor: "#9FA8DA",
    opacity: 1.79,
    height: 80
  }
};

const tcStyle = {
  paddingLeft: 10,
  paddingRight: 10,
  textAlign: "center"
};

const makeFirstTBody = (v, i) => (
  <Tr key={`first-${i}`} style={i % 2 === 0 ? styleTable.even : styleTable.odd}>
    <Tc style={tcStyle}>{`${i + 1}位`}</Tc>
    <Tc style={tcStyle}>{v.number}</Tc>
    <Tc style={{ ...tcStyle, textAlign: "left" }}>{v.item}</Tc>
    <Tc style={tcStyle}>
      {v.point === "計算不能" ? v.point : toFixed(v.point, 3)}
    </Tc>
  </Tr>
);

const makeSecondTBody = (v, i) => (
  <Tr
    key={`second-${i}`}
    style={i % 2 === 0 ? styleTable.even : styleTable.odd}
  >
    <Tc style={tcStyle}>{`${32 + i}位`}</Tc>
    <Tc style={tcStyle}>{v.number}</Tc>
    <Tc style={{ ...tcStyle, textAlign: "left" }}>{v.item}</Tc>
    <Tc style={tcStyle}>
      {v.point === "計算不能" ? v.point : toFixed(v.point, 3)}
    </Tc>
  </Tr>
);

const CorrelationCoefficientRanking = props => (
  <Fragment>
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      {props.firstData ?
        <div style={{ width: "49%" }}>
          <Paper>
            <Table>
              <Thead>
                <Tr>
                  <Tc style={{ ...styleTable.head, width: 35 }}>順位</Tc>
                  <Tc style={{ ...styleTable.head, width: 35 }}>番号</Tc>
                  <Tc style={styleTable.head}>質問項目</Tc>
                  <Tc style={{ ...styleTable.head, width: 55 }}>相関係数</Tc>
                </Tr>
              </Thead>
              <TBody>{props.firstData.map((v, i) => makeFirstTBody(v, i))}</TBody>
            </Table>
          </Paper>
        </div>
        : <span>集計に必要なデータが不足しているため表示できません。</span>}
      { props.secondData ?
        <div style={{ display: "inline-block", width: "49%" }}>
          <Paper>
            <Table>
              <Thead>
                <Tr>
                  <Tc style={{ ...styleTable.head, width: 35 }}>順位</Tc>
                  <Tc style={{ ...styleTable.head, width: 35 }}>番号</Tc>
                  <Tc style={styleTable.head}>質問項目</Tc>
                  <Tc style={{ ...styleTable.head, width: 55 }}>相関係数</Tc>
                </Tr>
              </Thead>
              <TBody>
                {props.secondData.map((v, i) => makeSecondTBody(v, i))}
              </TBody>
            </Table>
          </Paper>
        </div>
        : <span>集計に必要なデータが不足しているため表示できません。</span>}
    </div>
  </Fragment>
);

CorrelationCoefficientRanking.propTypes = {
  firstData: PropTypes.arrayOf(PropTypes.object).isRequired,
  secondData: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default CorrelationCoefficientRanking;



// WEBPACK FOOTER //
// ./src/components/ReportDetail/CorrelationCoefficientRanking.jsx